import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { headingTag } from './headingTag.js';
const styles = {
    h0: 'text-h0',
    h1: 'text-h1',
    h2: 'text-h2',
    h3: 'text-h3',
    h4: 'text-h4',
    h5: 'text-h5',
    h6: 'text-h6', // 20
};
export const Heading = JSX(({ className = '', headingType = 'h3', as = 'h3', title, children }) => {
    const Tag = headingTag(as);
    return (_jsx(Tag, { role: "heading", className: style('font-sans m-0', styles[headingType], className), children: title || children }));
});
//# sourceMappingURL=Heading.js.map